import { formatDisplayDateWithFormat } from 'syf-js-utilities';
import { paymentOptions, paymentTypes } from '../const/paymentOptions';
import { getPaymentAmountFromOption } from '../helpers';
import { getAnalyticsPaymentMethodTypeFromMedium, getAnalyticsPaymentOption } from '../machines/helpers';
import useApiMachine from './machines/useApiMachine';
import useFormValues from './machines/useFormValues';
import usePaymentFlowMachine from './machines/usePaymentFlowMachine';
const PaymentTypeMap = {
    [paymentTypes.ONCE]: 'one-time',
    [paymentTypes.PAYOFF]: 'payoff'
};
const DATE_FORMAT = 'MM-dd-yyyy';
const useAnalyticsPaymentFormValues = () => {
    const [apiMachine] = useApiMachine();
    const { paymentMethodsQueryResult, alternatePaymentMethodsQueryResult } = apiMachine.context;
    const paymentFormValues = useFormValues();
    const [paymentType, paymentFlowActor] = usePaymentFlowMachine();
    const { data: paymentMethodData } = paymentMethodsQueryResult;
    const { data: alternatePaymentMethodData } = alternatePaymentMethodsQueryResult;
    const paymentMethods = [
        ...paymentMethodData.paymentMethods,
        ...alternatePaymentMethodData.paymentMethods
    ];
    const { paymentOption: paymentOptionValue, paymentDate } = paymentFormValues;
    const paymentAmount = paymentOptionValue === paymentOptions.OTHER_PAYMENT ||
        (!paymentOptionValue && paymentFormValues.paymentAmount)
        ? paymentFormValues.paymentAmount
        : getPaymentAmountFromOption(paymentOptionValue, apiMachine.context);
    const paymentMethod = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find((method) => {
        return `${method === null || method === void 0 ? void 0 : method.id}` === (paymentFormValues === null || paymentFormValues === void 0 ? void 0 : paymentFormValues.paymentMethod);
    });
    const paymentOption = getAnalyticsPaymentOption(paymentOptionValue);
    const paymentSubmitDate = formatDisplayDateWithFormat(new Date(), DATE_FORMAT);
    const paymentScheduledDate = paymentDate && formatDisplayDateWithFormat(paymentDate, DATE_FORMAT);
    const paymentMethodType = getAnalyticsPaymentMethodTypeFromMedium(paymentMethod);
    const paymentFrom = (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.cardNumberLast4) || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.bankAccountNumberLast4);
    const mappedPaymentType = PaymentTypeMap[paymentType];
    const { shouldEnrollInOneClickAutopay } = paymentFlowActor.context;
    const oneClickAutopay = shouldEnrollInOneClickAutopay ? 'true' : 'false';
    return {
        paymentAmount,
        paymentMethod,
        paymentOption,
        paymentSubmitDate,
        paymentScheduledDate,
        paymentMethodType,
        paymentFrom,
        oneClickAutopay,
        paymentType: mappedPaymentType
    };
};
export default useAnalyticsPaymentFormValues;
